import { S3UploadFile } from "@/types/file-upload";
import { normalizePath, prependPublic } from "./path-utils";
import { normalizeFileName, resolveContentType } from "./file-format";

export const extractS3UploadFiles = (
  files: File[],
  prefix?: string,
): Array<S3UploadFile & { _safeFileName: string }> => {
  const cleanedPrefix = normalizePath(prefix || "");

  return files.map((file) => {
    const rawType = file.type || "";
    const contentType = resolveContentType(rawType);

    const rawName = file.webkitRelativePath || file.name.trim();
    const safeName = normalizeFileName(rawName);

    const finalPath = cleanedPrefix
      ? `${cleanedPrefix}/${safeName}`
      : safeName;

    return {
      filepath: prependPublic(finalPath),
      content_type: contentType,
      _safeFileName: safeName,
    };
  });
};

export const getDisplayFileNameFromFilePath = (filepath: string): string => {
  return filepath.split("/").pop() || filepath;
};
